// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__7BmmG","header":"styles_header__aKEyo","infoIcon":"styles_infoIcon__sFU-o","description":"styles_description__S1VsC"};